var map = {
	"./views/admin/backgroundAccount": [
		"3c4f",
		"chunk-6ede17e3"
	],
	"./views/admin/backgroundAccount.vue": [
		"3c4f",
		"chunk-6ede17e3"
	],
	"./views/art/artist": [
		"de35",
		"chunk-27edaf66"
	],
	"./views/art/artist.vue": [
		"de35",
		"chunk-27edaf66"
	],
	"./views/art/artwork": [
		"291d",
		"chunk-7a49dad3"
	],
	"./views/art/artwork.vue": [
		"291d",
		"chunk-7a49dad3"
	],
	"./views/art/collector": [
		"b33a",
		"chunk-60f7aa0a"
	],
	"./views/art/collector.vue": [
		"b33a",
		"chunk-60f7aa0a"
	],
	"./views/art/sortLabel": [
		"e840",
		"chunk-7b7a6b42"
	],
	"./views/art/sortLabel.vue": [
		"e840",
		"chunk-7b7a6b42"
	],
	"./views/banner": [
		"432a",
		"chunk-3f9c9bdd"
	],
	"./views/banner/": [
		"432a",
		"chunk-3f9c9bdd"
	],
	"./views/banner/index": [
		"432a",
		"chunk-3f9c9bdd"
	],
	"./views/banner/index.vue": [
		"432a",
		"chunk-3f9c9bdd"
	],
	"./views/components/artistsSelect": [
		"f355",
		"chunk-92849512"
	],
	"./views/components/artistsSelect.vue": [
		"f355",
		"chunk-92849512"
	],
	"./views/components/category": [
		"e26e",
		"chunk-718dff82"
	],
	"./views/components/category.vue": [
		"e26e",
		"chunk-718dff82"
	],
	"./views/components/collectorSelect": [
		"585a",
		"chunk-afc0dc16"
	],
	"./views/components/collectorSelect.vue": [
		"585a",
		"chunk-afc0dc16"
	],
	"./views/components/uploadDocument": [
		"2d75",
		"chunk-35996014"
	],
	"./views/components/uploadDocument.vue": [
		"2d75",
		"chunk-35996014"
	],
	"./views/components/uploadList": [
		"03f1",
		"chunk-28472d0d"
	],
	"./views/components/uploadList.vue": [
		"03f1",
		"chunk-28472d0d"
	],
	"./views/components/uploadVideo": [
		"998e",
		"chunk-1656359a"
	],
	"./views/components/uploadVideo.vue": [
		"998e",
		"chunk-1656359a"
	],
	"./views/dashboard": [
		"9406",
		"chunk-eabb021c"
	],
	"./views/dashboard/": [
		"9406",
		"chunk-eabb021c"
	],
	"./views/dashboard/index": [
		"9406",
		"chunk-eabb021c"
	],
	"./views/dashboard/index.vue": [
		"9406",
		"chunk-eabb021c"
	],
	"./views/error/401": [
		"ec55",
		"chunk-5edb3fc2"
	],
	"./views/error/401.vue": [
		"ec55",
		"chunk-5edb3fc2"
	],
	"./views/error/404": [
		"2754",
		"chunk-75424564"
	],
	"./views/error/404.vue": [
		"2754",
		"chunk-75424564"
	],
	"./views/info": [
		"e37e",
		"chunk-031943cc"
	],
	"./views/info/": [
		"e37e",
		"chunk-031943cc"
	],
	"./views/info/index": [
		"e37e",
		"chunk-031943cc"
	],
	"./views/info/index.vue": [
		"e37e",
		"chunk-031943cc"
	],
	"./views/layout/Empty": [
		"eefe",
		"chunk-2d231255"
	],
	"./views/layout/Empty.vue": [
		"eefe",
		"chunk-2d231255"
	],
	"./views/layout/Layout": [
		"d9ce"
	],
	"./views/layout/Layout.vue": [
		"d9ce"
	],
	"./views/layout/components": [
		"38e2"
	],
	"./views/layout/components/": [
		"38e2"
	],
	"./views/layout/components/AppMain": [
		"177e"
	],
	"./views/layout/components/AppMain.vue": [
		"177e"
	],
	"./views/layout/components/Navbar": [
		"a10a"
	],
	"./views/layout/components/Navbar.vue": [
		"a10a"
	],
	"./views/layout/components/Settings": [
		"e9a9"
	],
	"./views/layout/components/Settings/": [
		"e9a9"
	],
	"./views/layout/components/Settings/index": [
		"e9a9"
	],
	"./views/layout/components/Settings/index.vue": [
		"e9a9"
	],
	"./views/layout/components/Sidebar": [
		"30c6"
	],
	"./views/layout/components/Sidebar/": [
		"30c6"
	],
	"./views/layout/components/Sidebar/Item": [
		"b2c3"
	],
	"./views/layout/components/Sidebar/Item.vue": [
		"b2c3"
	],
	"./views/layout/components/Sidebar/Logo": [
		"399b"
	],
	"./views/layout/components/Sidebar/Logo.vue": [
		"399b"
	],
	"./views/layout/components/Sidebar/SidebarItem": [
		"e9ca"
	],
	"./views/layout/components/Sidebar/SidebarItem.vue": [
		"e9ca"
	],
	"./views/layout/components/Sidebar/index": [
		"30c6"
	],
	"./views/layout/components/Sidebar/index.vue": [
		"30c6"
	],
	"./views/layout/components/TagsView": [
		"9bb8"
	],
	"./views/layout/components/TagsView/": [
		"9bb8"
	],
	"./views/layout/components/TagsView/ScrollPane": [
		"a3f8"
	],
	"./views/layout/components/TagsView/ScrollPane.vue": [
		"a3f8"
	],
	"./views/layout/components/TagsView/index": [
		"9bb8"
	],
	"./views/layout/components/TagsView/index.vue": [
		"9bb8"
	],
	"./views/layout/components/index": [
		"38e2"
	],
	"./views/layout/components/index.js": [
		"38e2"
	],
	"./views/layout/mixin/ResizeHandler": [
		"6777"
	],
	"./views/layout/mixin/ResizeHandler.js": [
		"6777"
	],
	"./views/login": [
		"9ed6",
		"chunk-f8dfb3ca"
	],
	"./views/login/": [
		"9ed6",
		"chunk-f8dfb3ca"
	],
	"./views/login/index": [
		"9ed6",
		"chunk-f8dfb3ca"
	],
	"./views/login/index.vue": [
		"9ed6",
		"chunk-f8dfb3ca"
	],
	"./views/newsCenter": [
		"3465",
		"chunk-a0822c1e"
	],
	"./views/newsCenter/": [
		"3465",
		"chunk-a0822c1e"
	],
	"./views/newsCenter/index": [
		"3465",
		"chunk-a0822c1e"
	],
	"./views/newsCenter/index.vue": [
		"3465",
		"chunk-a0822c1e"
	],
	"./views/redirect": [
		"ef3c",
		"chunk-2d230fe7"
	],
	"./views/redirect/": [
		"ef3c",
		"chunk-2d230fe7"
	],
	"./views/redirect/index": [
		"ef3c",
		"chunk-2d230fe7"
	],
	"./views/redirect/index.vue": [
		"ef3c",
		"chunk-2d230fe7"
	],
	"./views/system/permissionSetting/menuManagement": [
		"2b8c",
		"chunk-5e11f1fe"
	],
	"./views/system/permissionSetting/menuManagement.vue": [
		"2b8c",
		"chunk-5e11f1fe"
	],
	"./views/system/permissionSetting/roleManagement": [
		"7375",
		"chunk-a59de29a"
	],
	"./views/system/permissionSetting/roleManagement.vue": [
		"7375",
		"chunk-a59de29a"
	],
	"./views/user": [
		"e382",
		"chunk-b4d0271e"
	],
	"./views/user/": [
		"e382",
		"chunk-b4d0271e"
	],
	"./views/user/charge": [
		"8744",
		"chunk-724f377a"
	],
	"./views/user/charge.vue": [
		"8744",
		"chunk-724f377a"
	],
	"./views/user/childList": [
		"bdcc",
		"chunk-4a845d12"
	],
	"./views/user/childList.vue": [
		"bdcc",
		"chunk-4a845d12"
	],
	"./views/user/dpWallet": [
		"c993",
		"chunk-38b9ac10"
	],
	"./views/user/dpWallet.vue": [
		"c993",
		"chunk-38b9ac10"
	],
	"./views/user/dpWalletRecord": [
		"5fa5",
		"chunk-1f000e84"
	],
	"./views/user/dpWalletRecord.vue": [
		"5fa5",
		"chunk-1f000e84"
	],
	"./views/user/index": [
		"e382",
		"chunk-b4d0271e"
	],
	"./views/user/index.vue": [
		"e382",
		"chunk-b4d0271e"
	],
	"./views/user/invitationRanking": [
		"45f8",
		"chunk-45d23a3e"
	],
	"./views/user/invitationRanking.vue": [
		"45f8",
		"chunk-45d23a3e"
	],
	"./views/user/linkedMerchant": [
		"a064",
		"chunk-917e4eec"
	],
	"./views/user/linkedMerchant.vue": [
		"a064",
		"chunk-917e4eec"
	],
	"./views/user/otcWallet": [
		"ac09",
		"chunk-4fef2d90"
	],
	"./views/user/otcWallet.vue": [
		"ac09",
		"chunk-4fef2d90"
	],
	"./views/user/otcWalletRecord": [
		"596f",
		"chunk-13c0c8ce"
	],
	"./views/user/otcWalletRecord.vue": [
		"596f",
		"chunk-13c0c8ce"
	],
	"./views/user/team": [
		"c128",
		"chunk-79e9b49a"
	],
	"./views/user/team.vue": [
		"c128",
		"chunk-79e9b49a"
	],
	"./views/user/whitelist": [
		"50f7",
		"chunk-df015952"
	],
	"./views/user/whitelist.vue": [
		"50f7",
		"chunk-df015952"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2a68";
module.exports = webpackAsyncContext;